import React from 'react'
import { toTitleCase } from '@mobi/utils/string'
import type { Selection, SameRaceMultiSelection, BettingType, Race } from '@mobi/betslip/types'
import { isSameRaceMultiSelection } from '@mobi/betslip/helpers/typeGuards'
import { Icon } from '@mobi/component-library/Common/Icon'
import { Flex } from '@mobi/component-library/Common/Flex'
import { spacing } from '@mobi/component-library/Theme/Common'
import { getIconTypeFromMeetingCode } from '@core/Areas/Quickbet/helpers/IconTypeHelper'
import { getFixedOrToteDisplay, getMarketTitle } from '@core/Areas/Quickbet/helpers/selections'
import { SecondaryInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/SecondaryInfo'
import { EventInfo } from '@core/Areas/Quickbet/Components/BetSelectionInfo/Components/Common/EventInfo'

export const RaceInfo: React.FC<{
  race: Race
  selection: Selection
  bettingType: BettingType
  isRaceClosed?: boolean
}> = ({ race, selection, bettingType, isRaceClosed = false }) => {
  const { raceNumber, meetingName, raceTime } = race

  const isSameRaceMulti =
    selection != null && isSameRaceMultiSelection(selection as SameRaceMultiSelection)
  const fixedOrToteDisplay = isSameRaceMulti ? '' : getFixedOrToteDisplay(selection, bettingType)
  const marketName = isSameRaceMulti ? 'Same Race Multi' : getMarketTitle(selection)

  const iconType = getIconTypeFromMeetingCode(race.meetingCode)
  return (
    <Flex flexDirection='column' gap={spacing.smx2}>
      <EventInfo
        icon={iconType && <Icon size='2.2rem' type={iconType} />}
        eventInfo={`${toTitleCase(meetingName)} : R${raceNumber}`}
      />

      <SecondaryInfo
        marketInfo={
          <>
            {marketName && <span>{marketName}</span>}
            {fixedOrToteDisplay.length > 0 && fixedOrToteDisplay.toUpperCase()}
          </>
        }
        eventStart={raceTime}
        isBettingClosed={isRaceClosed}
      />
    </Flex>
  )
}
